<template>
  <el-dialog
    title="DDEX"
    :visible="ddex_dialog"
    :fullscreen="true"
    :modal="true"
    @close="close"
    @open="open"
  >
    <el-form :model="ddex" class="ddex">
      <el-row>
        <el-col :span="7" class="mr20">
          <el-form-item label="Release title" prop="release_title" required>
            <el-input
                type="text"
                v-model="ddex.release_title"
                clearable
            />
          </el-form-item>
          <el-form-item label="Format" prop="format" required>
            <el-select v-model="ddex.format" placeholder="Select" clearable filterable>
              <el-option
                  v-for="item in format_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Artist" prop="artist" required>
            <el-select v-model="ddex.artist" placeholder="Select" clearable filterable>
              <el-option
                  v-for="item in ddex_artists"
                  :key="item.slug"
                  :label="item.name"
                  :value="item.slug">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Album" prop="album" required>
            <el-input type="text" v-model="ddex.album" clearable />
          </el-form-item>
          <el-form-item label="Record label" prop="record_label" required>
            <el-input type="text" v-model="ddex.record_label" clearable />
          </el-form-item>
          <el-form-item label="Asset label" prop="asset_label" required>
            <el-select v-model="ddex.asset_label" placeholder="Select" clearable filterable>
              <el-option
                  v-for="item in ddex_asset_labels"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="ISRC" prop="isrc" required>
            <el-input type="text" v-model="ddex.isrc" clearable />
          </el-form-item>
          <el-form-item label="UPC/EAN" prop="upc_ean" class="upc_ean" required>
            <el-input type="text" v-model="ddex.upc_ean" clearable />
            <el-tooltip content="Get UPC" placement="top">
              <el-button
                  icon="el-icon-s-tools"
                  type="success"
                  circle
                  @click="getUPC()"
              ></el-button>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <el-col :span="7" class="mr20">
          <el-form-item label="Language" prop="language" required>
            <el-select v-model="ddex.language" placeholder="Select" clearable filterable>
              <el-option
                  v-for="item in ddex_languages"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Genre" prop="genre" required>
            <el-select v-model="ddex.genre" placeholder="Select" clearable filterable>
              <el-option
                  v-for="item in ddex_genres"
                  :key="item.slug"
                  :label="item.name"
                  :value="item.slug">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Copyright C Line Year" prop="c_line_year" required>
            <el-input type="number" v-model="ddex.c_line_year" clearable />
          </el-form-item>
          <el-form-item label="Copyright C Line text" prop="c_line_text" required>
            <el-input type="text" v-model="ddex.c_line_text" clearable />
          </el-form-item>
          <el-form-item label="Copyright P Line Year" prop="p_line_year" required>
            <el-input type="number" v-model="ddex.p_line_year" clearable />
          </el-form-item>
          <el-form-item label="Copyright P Line text" prop="p_line_text" required>
            <el-input type="text" v-model="ddex.p_line_text" clearable />
          </el-form-item>
          <el-form-item label="Release Date" prop="release_date" required>
            <el-date-picker
                v-model="ddex.release_date"
                type="date"
                placeholder="Release Date">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="Policy" prop="policy" required>
            <el-select v-model="ddex.policy" placeholder="Select" clearable filterable>
              <el-option
                  v-for="item in policies"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item class="contributor_roles">
          <el-button @click="addContributorRoles">Add Contributor Roles</el-button>
        </el-form-item>
          <div v-for="(link, index) in ddex.contributor_roles" :key="link.key">
            <el-form-item  :label="`Contributor role`"
                           :prop="'contributor_roles.' + index + 'value'">
              <el-select v-model="link.value" placeholder="Select">
                <el-option
                    v-for="item in ddex_roles"
                    :key="item.name"
                    :label="item.name"
                    :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="contributor_roles-input" :label="`Contributor role name`"
                          :prop="'contributor_roles.' + index + 'description'" >
              <el-input v-model="link.name"></el-input>
              <el-button @click.prevent="removeContributorRoles(link)">Delete</el-button>
            </el-form-item>
          </div>
          <el-button
              type="primary"
              size="mini"
              @click="submit()"
              class="float-right"
          >
            Submit
          </el-button>
        </el-col>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  components: {
  },

  data() {
    return {
      format_options:[{
        value: 'single',
        label: 'Single'
      }/*, {
        value: 'album',
        label: 'Album'
      }*/],
      policies:[{
        value: 'monetize',
        label: 'Monetize All'
      }, {
        value: 'block',
        label: 'Block All'
      }, {
        value: 'review',
        label: 'Route to Review'
      }, {
        value: 'track',
        label: 'Track policy'
      }, {
        value: 'customize',
        label: 'Customize'
      }],

    }
  },

  computed: {

    ...mapState('trackImport', [
      'loading',
      'dialog_track',
      'dialog_artist_type',
      'track',
      'ddex_step',
      'ddex_dialog',
      'ddex',
      'ddex_roles',
      'ddex_languages',
      'ddex_genres',
      'ddex_upc',
      'ddex_asset_labels',
      'ddex_artists'
    ])
  },

  methods: {
    ...mapActions('trackImport', ['readDDEXLanguages','readDDEXRoles','readDDEXGenres', 'getDDEXUpc','readDDEXArtists',
    'readDDEXAssetLabels', 'generateDDEX']),
    ...mapMutations('trackImport', ['setDialogDDEX']),

    submit() {
      console.log('Ahoje ddex '+JSON.stringify(this.ddex))
      this.generateDDEX()
    },

    close() {
      this.setDialogDDEX(false)
    },

    async getUPC(){
      await this.getDDEXUpc()
      this.ddex.upc_ean = this.ddex_upc
    },

    open() {
      this.readDDEXGenres()
      this.readDDEXLanguages()
      this.readDDEXRoles()
      this.readDDEXArtists()
      this.readDDEXAssetLabels()
      this.setDDEX()
    },

    removeContributorRoles(link) {
      const index = this.ddex.contributor_roles.indexOf(link);

      if (index !== -1) {
        this.ddex.contributor_roles.splice(index, 1);
      }

    },

    addContributorRoles() {
      let contributorRoles = this.ddex.contributor_roles
      contributorRoles.push({key: new Date().getTime(), value: ''})
    },

    setDDEX(){
      if(this.track.title !== null) this.ddex.release_title = this.track.cid_release_title;
      if(this.track.format !== null) this.ddex.format = this.track.cid_format;
      if(this.track.artist !== null && this.track.artist.slug !== null) this.ddex.artist = this.track.artist.slug;
      if(this.track.album !== null) this.ddex.album = this.track.album;
      if(this.track.record_label !== null) this.ddex.record_label = this.track.record_label;
      if(this.track.isrc !== null) this.ddex.isrc = this.track.isrc;
      if(this.track.genres.length > 0) this.ddex.genre = this.track.genres[0];
      if(this.track.cid_c_line_year !== null) this.ddex.c_line_year = this.track.cid_c_line_year; else this.ddex.c_line_year = new Date().getFullYear()
      if(this.track.cid_c_line_text !== null) this.ddex.c_line_text = this.track.cid_c_line_text;
      if(this.track.cid_p_line_year !== null) this.ddex.p_line_text = this.track.cid_p_line_text; this.ddex.p_line_year = new Date().getFullYear()
      if(this.track.cid_p_line_text !== null) this.ddex.p_line_text = this.track.cid_p_line_text;
      if(this.track.cid_asset_label !== null) this.ddex.asset_label = this.track.cid_asset_label;
      if(this.track.cid_upc_ean !== null) this.ddex.upc_ean = this.track.cid_upc_ean;
      if(this.track.cid_language !== null) this.ddex.language = this.track.cid_language;

      if(this.track.cid_policy !== null) this.ddex.policy = this.track.cid_policy;
      if(this.track.cid_ !== null) this.ddex.release_date = this.track.timing_start;

    }

  },
}
</script>

<style scoped lang="scss">


</style>
